import  request  from '../../Interceptor/request.js'

//获取全部信息
export function waterContent(data) {
    return request({
        url: '/waterBill/list',
        method: 'get',
        params:data
    })
}

//月查询
export function waterMonthContent(data) {
    return request({
        url: '/waterBillMonth/betweenTime',
        method: 'get',
        params:data
    })
}

//支付获取订单编号
export function paymentOrder(data) {
    return request({
        url: '/order',
        method: 'post',
        data:data
    })
}


//订单编号获取appid
export function orderApp(data) {
    return request({
        url: '/pay/wxPay/mp-pay',
        method: 'get',
        params:data
    })
}

//订单查询
export function orderQuery(data) {
    return request({
        url: '/order/list',
        method: 'get',
        params:data
    })
}
